/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CcspProfileEvent = {
  type?: CcspProfileEvent.type;
  brand?: string;
  carID?: string;
  userID?: string;
  vin?: string;
  profileID?: string;
  driverIndex?: number;
};
export namespace CcspProfileEvent {
  export enum type {
    _100 = '100',
    _101 = '101',
    _102 = '102',
    _103 = '103',
    _104 = '104',
    _105 = '105',
    _1 = '-1',
  }
}

